import * as Zod from 'zod';
import { apartmentScheme } from '@features/effector-form/controls/apartment/validation';
import { buildingScheme } from '@features/effector-form/controls/buildings-filter-control/validation';
import { employeeScheme } from '@features/effector-form/controls/employees/validation';
import { invoiceStatusScheme } from '@features/effector-form/controls/invoice-status/validation';
import { peopleSearchValidation } from '@features/effector-form/controls/people-search/validation';
import { ticketClassScheme } from '@features/effector-form/controls/ticketClass/validation';
import { ticketPriorityScheme } from '@features/effector-form/controls/ticketPriority/validation';
import { ticketStatusScheme } from '@features/effector-form/controls/ticketStatus/validation';
import i18n from '@shared/config/i18n';

export const validationSchema = Zod.object({
  periodOfCreation: Zod.tuple([Zod.date().nullable(), Zod.date().nullable()]),
  statuses: Zod.array(ticketStatusScheme),
  isTehzor: Zod.boolean(),
  isSupportActive: Zod.boolean(),
  priorities: Zod.array(ticketPriorityScheme),
  classes: Zod.array(ticketClassScheme),
  types: Zod.array(Zod.string()),
  payment: Zod.string().nullable(),
  invoiceStatus: invoiceStatusScheme.nullable(),
  objects: Zod.array(Zod.number()),
  houses: Zod.array(buildingScheme),
  apartments: Zod.array(apartmentScheme),
  property: Zod.array(Zod.number()),
  initiators: Zod.array(peopleSearchValidation),
  stuffWriteOffNeeded: Zod.string().nullable(),
  expired: Zod.string().nullable(),
  assignees: Zod.array(employeeScheme),
  rates: Zod.array(
    Zod.object({
      id: Zod.string(),
      label: Zod.string(),
    })
  ),
  isUnreadMessage: Zod.boolean(),
  hasRelated: Zod.boolean(),
}).superRefine(({ periodOfCreation: [startDate, endDate] }, ctx) => {
  if (startDate && !endDate) {
    ctx.addIssue({
      code: Zod.ZodIssueCode.custom,
      message: String(i18n.t('chooseEndDate')),
      path: ['periodOfCreation'],
    });

    return;
  }

  if (!startDate && endDate) {
    ctx.addIssue({
      code: Zod.ZodIssueCode.custom,
      message: String(i18n.t('chooseStartDate')),
      path: ['periodOfCreation'],
    });

    return;
  }

  if (startDate && endDate && endDate.getTime() < startDate.getTime()) {
    ctx.addIssue({
      code: Zod.ZodIssueCode.custom,
      message: String(i18n.t('StartDateBeforeOrEqualEndDate')),
      path: ['periodOfCreation'],
    });
  }
});
